import type { AuthorizedUser } from './authorized-user';
import type { Permission } from './permissions';

/**
 * Central authorization check. Per docs/architecture/02-security-architecture.md,
 * this is the ONLY sanctioned way to check access in application code —
 * role names must never be compared directly (`user.role === 'admin'`) outside this file.
 */
export function can(user: AuthorizedUser | null, permission: Permission): boolean {
  if (!user) {
    return false;
  }
  return user.permissions.includes(permission);
}
